import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { TitleCard } from '../QualityPage/MetricsSection/MetricsHelpfullComponents';
import apiService from '../../services/apiService';

//  <DeployFlag deployFlag={deploymentData.deployed} />
export const Card = ({
  deploymentData,
  tooltipMessage,
  title,
  arrayOfConfigs,
  projectId,
  selectedProject
}) => {
  const [selectedConfig, setSelectedConfig] = useState({ type: 'oath', service: 'github' });

  return (
    <div style={{ width: '50%', margin: '0.1rem' }}>
      <TitleCard title={title} tooltipMessage={tooltipMessage} />
      <div
        style={{
          padding: '1rem',
          border: 'solid',
          borderBottomLeftRadius: '0.5rem',
          borderBottomRightRadius: '0.5rem',
          borderColor: '#0c4d82',
          height: '75%',
          display: 'grid',
          gridTemplateRows: '2fr 1fr'
        }}
      >
        <section
          style={{
            display: 'grid',
            gridTemplateRows: '1fr 1fr 1fr'
          }}
        >
          {' '}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
            <span style={{ color: '#0c4d82' }}>Service: </span> {selectedConfig.service}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
            <span style={{ color: '#0c4d82' }}>Authentication type: </span> {selectedConfig.type}
          </div>
        </section>
        <section
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '40%',
            alignItems: 'center',
            justifyItems: 'center'
          }}
        >
          <CancelButton setSelectedConfig={setSelectedConfig} />
          <DeployButton projectIdToDeploy={projectId} />
        </section>
      </div>
    </div>
  );
};

export const DeployFlag = ({ selectedConfig }) => {
  const [deployFlag, setDeployFlag] = useState(false);
  useEffect(() => {
    if (!selectedConfig.serverIpAddress) return;
    if (selectedConfig.serverName === 'local') setDeployFlag(false);
    else {
      apiService
        .doAction({
          url: `${selectedConfig.url}/hello`,
          method: 'GET'
        })
        .then((res) => {
          setDeployFlag(res.status === 200);
        })
        .catch(() => setDeployFlag(false));
    }
  }, [selectedConfig]);
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Authentication: </span>
      <div>
        <span
          style={{
            height: '1rem',
            width: '1rem',
            backgroundColor: deployFlag ? 'green' : 'red',
            borderRadius: '50%',
            display: 'inline-block'
          }}
        />
        <span>&nbsp; {deployFlag ? 'Online' : 'Offline'}</span>
      </div>
    </div>
  );
};

const ServerSelection = ({
  arrayOfConfigs,
  selectedConfig,
  setSelectedConfig,
  projectId,
  selectedProject
}) => {
  const optionsArray = arrayOfConfigs.map((config) => (
    <option key={`${config._id}`} value={config._id}>
      {config.serverName} {config.name}
    </option>
  ));

  const upgradeProject = async (deployConfigId) => {
    if (selectedProject === -1) return;
    const projects = JSON.parse(localStorage.getItem('data'));
    apiService
      .updateProject3(projectId, { deployConfiguration: deployConfigId })
      .then((res) => apiService.getDeployConfig(res.data.deployConfiguration))
      .then((res) => {
        projects[selectedProject].deployConfiguration = res;
        localStorage.setItem('data', JSON.stringify(projects));
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  async function handleSelection(event) {
    event.preventDefault();
    try {
      upgradeProject(event.target.value).then((configId) => {
        setSelectedConfig((prev) => {
          if (configId && prev?._id !== configId?._id) return configId;
          return prev;
        });
      });
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', alignItems: 'center' }}>
      <span style={{ color: '#0c4d82' }}>Deploy server: </span>
      {selectedConfig?._id && (
        <select
          value={selectedConfig._id}
          onChange={handleSelection}
          style={{ borderWidth: '0', width: '40%', minWidth: 'fit-content' }}
        >
          {optionsArray}
        </select>
      )}
    </div>
  );
};

const DeployButton = ({ projectIdToDeploy }) => {
  const [deploymentStatus, setDeploymentStatus] = useState('settled');

  function clickDeploy() {
    // apiService
    //   .deployAProject(projectId)
    //   .then(() => setDeploymentStatus('loading'))
    //   .catch((error) => {
    //     throw error;
    //   });
  }
  if (deploymentStatus === 'settled')
    return (
      <button
        type="button"
        className={clsx('cleanCssButton', 'teamselector')}
        onClick={() => clickDeploy(projectIdToDeploy)}
        style={{
          color: 'white',
          backgroundColor: '#0c4d82',
          border: '0.2rem solid #0c4d82',
          borderRadius: '0.5rem',
          width: '75%'
        }}
      >
        Save
      </button>
    );
  return (
    <div
      style={{
        width: '75%'
      }}
    >
      {' '}
      <Spinner
        projectIdToDeploy={projectIdToDeploy}
        setDeploymentStatus={setDeploymentStatus}
      />{' '}
    </div>
  );
};

function checkActionsStatus(actions) {
  if (actions.filter((action) => action.status !== 'completed').length) return false;
  return true;
}

function checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus) {
  apiService
    .listProjectActions(projectIdToDeploy)
    .then((answer) => {
      if (checkActionsStatus(answer.data.actions)) setDeploymentStatus('settled');
      else setDeploymentStatus('loading');
    })
    .catch((error) => {
      setDeploymentStatus('settled');
      throw error;
    });
}

const Spinner = ({ projectIdToDeploy, setDeploymentStatus }) => {
  useEffect(() => {
    let timerId;
    if (projectIdToDeploy)
      timerId = setInterval(
        () => checkProjectActionsOnInterval(projectIdToDeploy, setDeploymentStatus),
        10000
      );
    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, [projectIdToDeploy]);
  return <div id="cover-spin3" />;
};

const CancelButton = ({ setSelectedConfig }) => (
  <button
    type="button"
    className={clsx('cleanCssButton', 'teamselector')}
    onClick={() => {
      setSelectedConfig({ service: '', type: '' });
    }}
    style={{
      color: '#0c4d82',
      border: '0.2rem solid #0c4d82',
      borderRadius: '0.5rem',
      width: '75%'
    }}
  >
    Clear
  </button>
);
